import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import AdminLayout from "../UI/Layout/AdminLayout";
import Title from "../UI/Text/Title";
import Spining from "../UI/Spining/Spining";
import api from "../../axios/Axios";
import { userloginDetails } from "../Utils/AdminAuth";
import Select from "react-select";
import { HOST_URL, HOST_URL_DB2 } from "../Dashboard/api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faCalendarAlt, faDownload, faEye, faInfoCircle, faSearch, faSort } from "@fortawesome/free-solid-svg-icons";
import { IoLogoWhatsapp } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import dayjs from "dayjs";
import WhatsappCampaignListPreview from "../Dashboard/whatsapp/components/WhatsappCampaignListPreview";
import Axios from "../../axios/Axios";

const AdminCampaignReport = () => {
  const lStorage = userloginDetails();
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const adminType = lStorage.user.isAdmin;
  const subAdminPermission = lStorage?.permission?.per_value
  const [alert, setAlert] = useState({
    status: false,
    bgColor: "",
    errorMessage: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [fromdate, setFromdate] = useState(new Date());
  const [todate, setTodate] = useState(new Date());
  const [allusers, setAllusers] = useState([{ value: "", label: "All Users" }]);
  const [seleteduser, setSeletedusers] = useState("");
  const [totalCost, setTotalCost] = useState(null);
  const [totalFailed, setTotalFailed] = useState(null);
  const [totalDelivered, setTotalDeliverd] = useState(null);
  const [totalSent, setTotalSent] = useState(null);
  const [totaOptout, setTotalOptout] = useState(null);
  const [totalRead, setTotalRead] = useState(null);
  const [totalData, setTotalData] = useState(null);
  const [openTemplatePopup, setOpenTemplatePopup] = useState(false)
  const [templateDetails, setTemplateDetails] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalScheduleDelete, setTotalScheduleDelete] = useState(0);
  const [routeData, setRouteData] = useState('');
  const [openAccordion, setOpenAccordian] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [tooltipIndex, setTooltipIndex] = useState(null);
  const ITEMS_PER_PAGE = 10;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      cursor: "pointer",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (style) => ({
      ...style,
      fontSize: "12px",
    }),
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 640;
  const isTablet = windowWidth >= 640 && windowWidth < 1024;

  useEffect(() => {
    usersList();
    campaigndata();
    RouteDetails();
  }, []);


  const RouteDetails = () => {
    const payload = {
      user_id: userId,
      method: "retrieve",
      token: userToken,
      type: adminType,
    };

    fetch(`${HOST_URL}/route.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          setRouteData(result.data)
        }
      })
      .catch((error) => {
        console.error("Error fetching route details:", error);
      });
  }

  const usersList = async () => {
    try {
      setIsLoading(true);

      const payload = {
        user_id: userId,
        method: "retrieve_whatsapp_user",
        type: adminType,
        token: userToken,
      };

      let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (data.success) {
        let filterData = data.data.map((x) => ({
          value: x.user_id,
          label: x.user_name,
        }));
        setAllusers(filterData);
      } else {
        console.error("Error:", data.message);
      }
    } catch (error) {
      console.error("Request failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // console.log(allusers)


  const currentDate = (currentDate) => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const campaigndata = async () => {
    setIsLoading(true);
    let sDate = currentDate(fromdate);
    let eDate = currentDate(todate);

    // if (adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.read)) {
      try {
        const payload = {
          user_id: userId,
          method: "retrieve_admin",
          token: userToken,
          channel: "whatsapp",
          from_date: sDate,
          to_date: eDate,
          seacrh_user_id: seleteduser,
        };

        const { data } = await Axios.post(
          `https://console.authkey.io/api/bulk_campaign_sms.php`,
          payload,
        );

        if (data.success === true) {
          let totalCost = 0;
          let totaldelivered = 0;
          let totalsent = 0;
          let totaloptout = 0;
          let totalread = 0;
          let totalfailed = 0;
          let contactCount = 0;
          let totalScheduleDelete = 0;

          data.data.forEach((item) => {
            if (item.status !== 6) {
              totalCost += parseFloat(item.campaign_cost);
              totaldelivered += item.delivered;
              totalsent += item.sent;
              totaloptout += item.optout;
              totalread += item.read;
              totalfailed += item.failed;
              contactCount += item.contact_count;
            } else {
              totalScheduleDelete += item.contact_count;
            }
          });

          setTotalData(contactCount);
          setTotalCost(totalCost);
          setTotalDeliverd(totaldelivered);
          setTotalFailed(totalfailed);
          setTotalRead(totalread);
          setTotalSent(totalsent);
          setTotalOptout(totaloptout);
          setTotalScheduleDelete(totalScheduleDelete); // new state
          setCampaign(data.data);
          setOpenAccordian([]);
          setCurrentPage(1);
        }
        else {
          setCampaign([]);
        }
      } catch (error) {
        console.error("Error fetching campaign data:", error);
      } finally {
        setIsLoading(false);
      }
    // }
  };


  const userHandler = (e) => {
    setSeletedusers(e.value);
  };

  const fromdateHandler = (data) => {
    setFromdate(data);
  };
  const todateHandler = (data) => {
    setTodate(data);
  };

  const TemplateListDetails = async (templateid) => {
    // Open the popup when starting to fetch template details
    setOpenTemplatePopup(true)

    const data = {
      token: userToken,
      user_id: userId,
      id: templateid,
      method: "retrieveid",
    };

    try {
      let response = await fetch(`${HOST_URL}/whatsapp_template.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      let result = await response.json();
      if (result.success) {
        setTemplateDetails(result.data)
      } else {
        setTemplateDetails(null)
      }
    } catch (error) {
      console.log(error);
      setTemplateDetails(null)
    }
  }

  const closePopup = () => {
    setOpenTemplatePopup(false)
  }

  const handleSortClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.contact_count - b.contact_count
        : b.contact_count - a.contact_count
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  };

  const Sortbydelivered = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.delivered - b.delivered
        : b.delivered - a.delivered
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  };

  const Sortbyfailed = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.failed - b.failed
        : b.failed - a.failed
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  };

  const Sortbysent = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.sent - b.sent
        : b.sent - a.sent
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  }

  const Sortbyread = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.read - b.read
        : b.read - a.read
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  }

  const Sortbyoptout = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.optout - b.optout
        : b.optout - a.optout
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  }

  const Sortbyother = () => {
    const sorted = [...campaign].sort((a, b) => {

      const otherA =
        parseInt(a.contact_count || 0) -
        (
          parseInt(a.delivered || 0) +
          parseInt(a.failed || 0) +
          parseInt(a.sent || 0) +
          parseInt(a.read || 0) +
          parseInt(a.optout || 0)
        );

      const otherB =
        parseInt(b.contact_count || 0) -
        (
          parseInt(b.delivered || 0) +
          parseInt(b.failed || 0) +
          parseInt(b.sent || 0) +
          parseInt(b.read || 0) +
          parseInt(b.optout || 0)
        );

      return sortOrder === "asc"
        ? otherA - otherB
        : otherB - otherA;
    });

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setCurrentPage(1);
  };

  const sortByDate = () => {
    const sorted = [...campaign].sort((a, b) => {
      const dateA = new Date(a.camp_start_datetime);
      const dateB = new Date(b.camp_start_datetime);
      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

    setCampaign(sorted);
    setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
    setCurrentPage(1);
  };

  const toggleAccordion = async (campaignId, fallbackKey, channel) => {
    const accordionKey = `${campaignId}-${fallbackKey}`;

    // 🔹 Check current state FIRST
    const isAlreadyOpen = openAccordion.includes(accordionKey);

    // 🔹 Toggle UI
    setOpenAccordian(prev => {
      if (isAlreadyOpen) {
        return prev.filter(key => key !== accordionKey);
      }
      return [...prev, accordionKey];
    });

    // 🔹 If closing → STOP
    if (isAlreadyOpen) return;

    // 🔹 API CALL (always runs when opening)
    let paramData = {
      user_id: userId,
      token: userToken,
      method: "retrieve_new_refid",
      ref_id: campaignId,
      channel: channel
    };

    try {
      // setLoading(true);
      const { data } = await Axios.post(
        `${HOST_URL_DB2}/bulk_campaign_sms.php`,
        paramData
      );

      if (!data.success) {
        // setError({
        //     successShow: true,
        //     bgColor: "alert alert-danger",
        //     errorMessage: `Fallback record for ${campaignId} is not found`
        // })
        // setTimeout(() => {
        //     window.scrollTo({ top: 0, behavior: "smooth" });
        // }, 100);
        return
      }

      const campaignData = data.data[0];
      // const parsedDataFallback = JSON.parse(fallback_condition)

      setCampaign(prevList =>
        prevList.map(campaign => {
          if (campaign.id !== campaignId) return campaign;

          const updatedFallback = { ...campaign.fallback_condition };
          const fb = updatedFallback[fallbackKey];

          if (fb && fb.channel === campaignData.campaign_type) {
            updatedFallback[fallbackKey] = {
              ...fb,
              FallbackData: campaignData
            };
          }

          // console.log(updatedFallback);


          return {
            ...campaign,
            fallback_condition: updatedFallback
          };
        })
      );

    } catch (error) {
      console.log(error);
    }
    // finally {
    //     setLoading(false);
    // }
  };

  // console.log(campaign);


  const downloadCampaign = async (item) => {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("method", "download_admin");
    formData.append("token", userToken);
    formData.append("channel", "whatsapp");
    formData.append("camp_user_id", item.user_id);
    formData.append("camp_id", item.id);
    formData.append("camp_user_email", item.user_name);
    formData.append("archive_status", item.archive_status);

    const response = await fetch(`${HOST_URL}/bulk_campaign_sms.php`, {
      method: "POST",
      body: formData,
    });

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `campaign_${item.id}.csv`); // or .zip/.xls depending on backend
    document.body.appendChild(link);
    link.click();
    link.remove();
  };



  return (
    <div>
      <AdminLayout>
        <Title isButton={false}> Campaign Report </Title>

        {campaign.length > 0 &&
          <div className="row">
            <div className="col-xl-12 col-xxl-5 d-flex">
              <div className="w-100">
                <div className="row">
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Data</h5>
                        <h6 className="mt-0 mb-0">{totalData}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Delivered</h5>
                        <h6 className="mt-0 mb-0">{totalDelivered}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Failed</h5>
                        <h6 className="mt-0 mb-0">{totalFailed}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Read</h5>
                        <h6 className="mt-0 mb-0">{totalRead}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Sent</h5>
                        <h6 className="mt-0 mb-0">{totalSent}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2 ">
                        <h5 className="card-title mb-0">Optout</h5>
                        <h6 className="mt-0 mb-0">
                          {totaOptout}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2 ">
                        <h5 className="card-title mb-0">Total Cost</h5>
                        <h6 className="mt-0 mb-0">
                          {parseFloat(totalCost).toFixed(2)}
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2 ">
                        <h5 className="card-title mb-0">Schedule Deleted</h5>
                        <h6 className="mt-0 mb-0">
                          {totalScheduleDelete}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        <div className="row">
          <div className="">
            {alert.status === true ? (
              <div className={alert.bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">{alert.errorMessage}</div>
              </div>
            ) : null}

            {isLoading && <Spining />}
            <div className="row justify-content-center">
              <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                <div className="card flex-fill ">
                  <div className="card-header">

                    <div className="row">
                      <div className="col-12 col-md-3">
                        <label>Select User</label>
                        <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                          <div className="input-group mb-2 mr-sm-2">
                            <Select
                              onChange={userHandler}
                              options={allusers}
                              isSearchable={true}
                              placeholder="All Users"
                              styles={customStyles}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <label>From:</label>
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </div>
                          <div>
                            <ReactDatePicker
                              className="form-control btn-block"
                              dateFormat="dd/MM/yyyy"
                              value={fromdate}
                              onChange={fromdateHandler}
                              selected={fromdate}
                              placeholderText="From Date"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <label>To:</label>
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </div>
                          <div>
                            <ReactDatePicker
                              className="form-control btn-block"
                              dateFormat="dd/MM/yyyy"
                              value={todate}
                              onChange={todateHandler}
                              selected={todate}
                              placeholderText="Date To"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-1">
                        <label></label>
                        <button
                          className="btn btn-success float-right"
                          onClick={campaigndata}
                        >
                          <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                        </button>
                      </div>
                    </div>
                  </div>
                  {isLoading === true ? (
                    <Spining />
                  ) : (
                    <div className="col-md-12 mt-2">
                      {campaign < 1 && (
                        <div className="card d-flex justify-content-center align-items-center ">
                          <h6 className="mt-2">No Record Found</h6>
                        </div>
                      )}
                      {(() => {
                        const totalPages = Math.ceil(campaign.length / ITEMS_PER_PAGE);
                        const paginatedCampaigns = campaign.slice(
                          (currentPage - 1) * ITEMS_PER_PAGE,
                          currentPage * ITEMS_PER_PAGE
                        );
                        return (
                          <>
                      {paginatedCampaigns?.map((item, i) => (
                        <div className="card" key={i}>
                          <div className="card-body">
                            <div className="d-flex flex-wrap justify-content-between" style={{ gap: "8px" }}>
                              <p>
                                {" "}
                                <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} />

                                <span>Campaign Name:{" "}</span>
                                <span style={{ fontWeight: "bold" }}>
                                  {item.campaign_name}{" "}
                                </span>{" "}
                              </p>
                              <p>
                                {(item.status === 0 || item.status === 1) ? (
                                  <span className="badge bg-info">
                                    Submitted
                                  </span>
                                ) : item.status === 2 ? (
                                  <span className="badge bg-info">
                                    Schedule
                                  </span>
                                ) : item.status === 3 ? (
                                  <span className="badge bg-success">
                                    Processing
                                  </span>
                                ) : item.status === 5 ? (
                                  <span className="badge bg-warning">
                                    Schedule
                                  </span>
                                ) : item.status === 4 ? (
                                  <span className="badge bg-primary ">
                                    Completed
                                  </span>
                                ) : item.status === 6 ? (
                                  <span className="badge bg-danger">
                                    Schedule Deleted
                                  </span>
                                ) : item.status === 7 ? (
                                  <>
                                    <span className="badge bg-danger ">
                                      Not Sent
                                      <span
                                        style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
                                        onMouseEnter={() => setTooltipIndex(i)}
                                        onMouseLeave={() => setTooltipIndex(null)}
                                      >
                                        <FontAwesomeIcon className="ml-1" icon={faInfoCircle} />
                                        {tooltipIndex === i && (
                                          <span style={{
                                            position: 'absolute',
                                            bottom: '130%',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            backgroundColor: '#333',
                                            color: '#fff',
                                            padding: '5px 10px',
                                            borderRadius: '6px',
                                            whiteSpace: 'nowrap',
                                            fontSize: '12px',
                                            zIndex: 9999,
                                            pointerEvents: 'none',
                                            fontWeight: 'normal',
                                          }}>
                                            Not Send Due to Template Rejection
                                            <span style={{
                                              position: 'absolute',
                                              top: '100%',
                                              left: '50%',
                                              transform: 'translateX(-50%)',
                                              borderWidth: '5px',
                                              borderStyle: 'solid',
                                              borderColor: '#333 transparent transparent transparent',
                                            }} />
                                          </span>
                                        )}
                                      </span>
                                    </span>
                                  </>
                                ) : null}

                              </p>
                              <p>Campaign Date: {dayjs(item.camp_start_datetime).format("DD/MM/YYYY h:mm A")}<FontAwesomeIcon className="ml-2" onClick={sortByDate} style={{ cursor: "pointer" }} icon={faSort} /></p>
                            </div>
                            <hr className="m-0 mb-1"></hr>
                            <div className="d-flex flex-wrap summary-data text-center" style={{ gap: "8px" }}>
                              <div className="mb-1">
                                <span className="text-muted"> total </span> <FontAwesomeIcon onClick={handleSortClick} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                <br />
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.contact_count}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted">
                                  {" "}
                                  Delivered{" "}
                                </span><FontAwesomeIcon onClick={Sortbydelivered} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                <br />
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.delivered}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Failed </span><FontAwesomeIcon onClick={Sortbyfailed} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.failed}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Sent </span><FontAwesomeIcon onClick={Sortbysent} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                <br />
                                <span className="textvalue">
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "}
                                  {item.sent}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Read </span><FontAwesomeIcon onClick={Sortbyread} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue">
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "}
                                  {item.read}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Optout </span><FontAwesomeIcon onClick={Sortbyoptout} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue">
                                  {" "}
                                  {item.optout}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Other </span><FontAwesomeIcon onClick={Sortbyother} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue">
                                  {" "}
                                  {parseInt(item.contact_count) - (parseInt(item.delivered) + parseInt(item.failed) + parseInt(item.sent) + parseInt(item.read) + parseInt(item.optout))}{" "}
                                </span>{" "}
                              </div>

                              <>
                                {item.archive_status === 1 ? null : <div className="mb-1">
                                  <span className="text-muted"> Report </span>
                                  <br />{" "}
                                  <Link
                                    to={`/admin/campaign-report/${item.user_id}/${item.id}/${item.user_name}/${item.contact_count}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <span className=" text-success">
                                      <FontAwesomeIcon className="mt-3" icon={faEye} />
                                    </span>
                                  </Link>
                                </div>}

                                {(adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.download)) && 
                                <div className="mb-1">
                                  <span className="text-muted"> Download </span>
                                  <br />
                                  <button
                                    onClick={() => downloadCampaign(item)}
                                    className="btn btn-link text-success p-0"
                                  >
                                    <FontAwesomeIcon className="mt-3" icon={faDownload} />
                                  </button>
                                </div>}

                              </>
                            </div>
                            <div className="d-flex flex-wrap justify-content-between mt-1" style={{ gap: "4px" }}>
                              <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                                <small className="m-0, p-0">
                                  <span style={{ color: "black", fontSize: "10px" }}>Campaign ID:</span> <span style={{ color: "#4c0af5" }}>{item.id}</span><span style={{ color: "black" }}>/</span>
                                </small>
                                <small className="m-0, p-0">
                                  <span style={{ color: "black", fontSize: "10px" }}>BrandNumber:</span> <span style={{ color: "#4c0af5" }}>{item.from_mobile}</span><span style={{ color: "black" }}>/</span>
                                </small>
                                {<small style={{ color: "black", fontSize: "10px" }}>Template ID: <span style={{ color: "#4c0af5" }}>{item?.template_id}</span><span className="no-style">/</span></small>}

                                {<small style={{ color: "black", fontSize: "10px" }}>Country Code: <span style={{ color: "#4c0af5" }}>{item.country_code}</span>/</small>}
                                {<small style={{ color: "black", fontSize: "10px" }}>Campaign Type: <span style={{ color: "#4c0af5" }}>{item.campaign_type === 1 ? <span>Normal</span> : <span>Customize</span>}</span>/</small>}
                                {<small style={{ color: "black", fontSize: "10px" }}>Submit From: <span style={{ color: "#4c0af5" }}>{item.submit_via}</span>/</small>}
                                {<small style={{ color: "black", fontSize: "10px" }}>Route ID: <span style={{ color: "#4c0af5" }}>
                                  {
                                    (Array.isArray(routeData)
                                      ? routeData.find(x => Number(x.id ?? x.route_id) === Number(item?.route_id))?.route_name
                                      : routeData?.[item?.route_id]?.route_name
                                    ) || item?.route_id
                                  }
                                </span>/</small>}
                                {<small style={{ color: "black", fontSize: "10px" }}>User Name: <span style={{ color: "#4c0af5" }}>{item.user_name}</span></small>}
                                <small
                                  style={{
                                    cursor: 'pointer',
                                    backgroundColor: openTemplatePopup ? '#f0f0f0' : 'transparent',
                                  }}
                                  className="ml-2"
                                  onClick={() => TemplateListDetails(item?.template_id)}>
                                  <FontAwesomeIcon icon={faInfoCircle} /></small>
                              </div>
                              <small style={{ color: "black" }}>
                                Campaign Cost: {" "}
                                <span style={{ color: "#4c0af5" }}>{parseFloat(item.campaign_cost).toFixed(2)}</span>
                              </small>
                            </div>
                            {item.is_fallback === 1 && (
                              <div className="mt-3">

                                {Object.keys(item.fallback_condition).map((x, index) => {

                                  const fb = item.fallback_condition[x];
                                  const fallbackData = fb.FallbackData || null;
                                  const accordionKey = `${item.id}-${x}`;
                                  const isOpen = openAccordion.includes(accordionKey);

                                  return (
                                    <div className="card mb-2 shadow-sm" key={x}>

                                      {/* ===== FALLBACK HEADER ===== */}
                                      <div
                                        className="card-header d-flex justify-content-between align-items-center"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => toggleAccordion(item.id, x, fb.channel)}
                                      >
                                        <div>
                                          <span className={fb.channel === "sms" ? "badge bg-success me-2" : "badge bg-primary me-2"}>
                                            Fallback {index + 1}
                                          </span>

                                          <span className="text-muted ml-3">
                                            Channel:
                                            <b className="ms-1">
                                              {fb.channel === "sms" ? "SMS" : "RCS"}
                                            </b>
                                          </span>
                                        </div>

                                        <span className="text-muted">
                                          {isOpen ? "▲" : "▼"}
                                        </span>
                                      </div>

                                   
                                      {isOpen && (
                                        <div className="card-body">

                                 
                                          <div className="row text-center gy-3">

                                            <div className="col-6 col-md">
                                              <small className="text-muted">Total</small>
                                              <div className="fw-bold">{fallbackData?.contact_count || 0}</div>
                                            </div>

                                            <div className="col-6 col-md">
                                              <small className="text-muted">Delivered</small>
                                              <div className="fw-bold">{fallbackData?.delivered || 0}</div>
                                            </div>

                                            <div className="col-6 col-md">
                                              <small className="text-muted">Failed</small>
                                              <div className="fw-bold">{fallbackData?.failed || 0}</div>
                                            </div>

                                            {fb.channel === "whatsapp" && (
                                              <>
                                                <div className="col-6 col-md">
                                                  <small className="text-muted">Sent</small>
                                                  <div className="fw-bold">{fallbackData?.sent || 0}</div>
                                                </div>

                                                <div className="col-6 col-md">
                                                  <small className="text-muted">Read</small>
                                                  <div className="fw-bold">{fallbackData?.read || 0}</div>
                                                </div>
                                              </>
                                            )}

                                            <div className="col-6 col-md">
                                              <small className="text-muted">Opt Out</small>
                                              <div className="fw-bold">{fallbackData?.optout || 0}</div>
                                            </div>

                                            {fb.channel === "sms" && (
                                              <>
                                                <div className="col-6 col-md">
                                                  <small className="text-muted">DND</small>
                                                  <div className="fw-bold">{fallbackData?.dnd || 0}</div>
                                                </div>

                                                <div className="col-6 col-md">
                                                  <small className="text-muted">Other</small>
                                                  <div className="fw-bold">{parseInt(fallbackData?.contact_count || 0) - (parseInt(fallbackData?.delivered || 0) + parseInt(fallbackData?.failed || 0) + parseInt(fallbackData?.optout || 0) + parseInt(fallbackData?.dnd || 0))}</div>
                                                </div>
                                              </>
                                            )}
                                          </div>

                                          {fallbackData &&
                                            <>
                                              <hr />


                                              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                                                <small>
                                                  Campaign ID:
                                                  <b className="ms-1">{fallbackData?.id}</b>
                                                  <span className="mx-1">|</span>
                                                  Cost:
                                                  <b className={fb.channel === "sms" ? "ms-1 text-primary" : "ms-1 text-success"}>
                                                    {parseFloat(fallbackData?.campaign_cost || 0).toFixed(2)}
                                                  </b>
                                                </small>

                                                <div className="d-flex gap-3">
                                                  {fallbackData.archive_status === 0 &&
                                                    <Link
                                                      to={
                                                        fb.channel === "whatsapp"
                                                          ? `/admin/campaign-report/${fallbackData?.user_id}/${fallbackData?.id}/${fallbackData?.user_name}/${fallbackData?.contact_count}`
                                                          : `/admin/campaign/detailed-report/${fb?.channel}/${fallbackData?.id}/${fallbackData?.user_name}/${fallbackData?.contact_count}`
                                                      }
                                                      target="_blank"
                                                      className={fb.channel === "whatsapp" ? "text-success mr-3" : "text-primary mr-3"}
                                                    >
                                                      <FontAwesomeIcon icon={faEye} /> Report
                                                    </Link>}

                                                 {(adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.download)) &&
                                                  <a
                                                    href={`${HOST_URL_DB2}/bulk_campaign_sms.php?user_id=${userId}&ret_user_id=${fallbackData?.user_id}&method=download&token=${userToken}&channel=sms&campaign_id=${fallbackData?.id}&archive_status=${fallbackData?.archive_status}&camp_start_datetime=${fallbackData?.camp_start_datetime}&type=${adminType}&username=${fallbackData?.user_name}`}
                                                    className={fb.channel === "whatsapp" ? "text-success" : "text-primary"}
                                                  >
                                                    <FontAwesomeIcon icon={faDownload} /> Download
                                                  </a>}
                                                </div>

                                              </div>
                                            </>}

                                        </div>
                                      )}

                                    </div>
                                  );
                                })}
                              </div>
                            )}

                          </div>
                        </div>
                      ))}

                      {/* ── PAGINATION ── */}
                      {campaign.length > ITEMS_PER_PAGE && (
                        <div style={{
                          display: 'flex',
                          flexDirection: isMobile ? 'column' : 'row',
                          justifyContent: 'space-between',
                          alignItems: isMobile ? 'stretch' : 'center',
                          padding: '14px 20px',
                          marginTop: '8px',
                          background: '#fff',
                          borderRadius: '12px',
                          boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                          gap: '10px',
                        }}>
                          {/* Info text */}
                          <span style={{ fontSize: '12.5px', color: '#6b7280', fontWeight: 600 }}>
                            Showing&nbsp;
                            <b style={{ color: '#374151' }}>
                              {(currentPage - 1) * ITEMS_PER_PAGE + 1}–{Math.min(currentPage * ITEMS_PER_PAGE, campaign.length)}
                            </b>
                            &nbsp;of&nbsp;
                            <b style={{ color: '#374151' }}>{campaign.length}</b>
                            &nbsp;campaigns
                          </span>

                          {/* Controls */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: isMobile ? 'space-between' : 'flex-end' }}>
                            {/* Prev */}
                            <button
                              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                              disabled={currentPage === 1}
                              style={{
                                padding: '6px 14px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '8px',
                                background: currentPage === 1 ? '#f9fafb' : '#fff',
                                color: currentPage === 1 ? '#9ca3af' : '#374151',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                fontWeight: 700,
                                fontSize: '13px',
                              }}
                            >← Prev</button>

                            {/* Page pills (hidden on mobile) / compact counter on mobile */}
                            {isMobile ? (
                              <span style={{ fontSize: '13px', color: '#374151', fontWeight: 700 }}>
                                {currentPage} / {totalPages}
                              </span>
                            ) : (
                              Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                                .reduce((acc, p, idx, arr) => {
                                  if (idx > 0 && p - arr[idx - 1] > 1) acc.push('…');
                                  acc.push(p);
                                  return acc;
                                }, [])
                                .map((p, idx) =>
                                  p === '…' ? (
                                    <span key={"el-" + idx} style={{ color: '#9ca3af', padding: '0 4px', fontSize: '14px' }}>…</span>
                                  ) : (
                                    <button
                                      key={p}
                                      onClick={() => setCurrentPage(p)}
                                      style={{
                                        padding: '6px 11px',
                                        border: '1.5px solid',
                                        borderColor: currentPage === p ? '#6366f1' : '#e5e7eb',
                                        borderRadius: '8px',
                                        background: currentPage === p ? '#6366f1' : '#fff',
                                        color: currentPage === p ? '#fff' : '#374151',
                                        cursor: 'pointer',
                                        fontWeight: 700,
                                        fontSize: '13px',
                                        minWidth: '34px',
                                      }}
                                    >{p}</button>
                                  )
                                )
                            )}

                            {/* Next */}
                            <button
                              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                              disabled={currentPage === totalPages}
                              style={{
                                padding: '6px 14px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '8px',
                                background: currentPage === totalPages ? '#f9fafb' : '#fff',
                                color: currentPage === totalPages ? '#9ca3af' : '#374151',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                fontWeight: 700,
                                fontSize: '13px',
                              }}
                            >Next →</button>
                          </div>
                        </div>
                      )}
                      </>
                        );
                      })()}
                    </div>
                  )}
                  <WhatsappCampaignListPreview templateDetails={templateDetails} openTemplatePopup={openTemplatePopup} closePopup={closePopup} />
                </div>
              </div>
            </div>

          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default AdminCampaignReport;
